export const persistence = {
  dbVersion: 1,
  dbName: 'aida-spa',
};
